
<canvas
	baseChart
	height="240px"
    [data]="chartData"
    [options]="chartOptions"
    [type]="'bar'">
</canvas>
